import { useSelector } from "react-redux";
import { selectProductsInCart, selectTradeInOrderAttributes } from "@jti/store";
export const useIsCheckoutBlockedByTradeIn = () => {
    const selectedTradeInOrderAttributes = useSelector(selectTradeInOrderAttributes);
    const { traded_in_model } = selectedTradeInOrderAttributes || {};
    const productsInCart = useSelector(selectProductsInCart);
    const isTradeInItemInCart = productsInCart.some((item) => !!item.tradeIn);
    return isTradeInItemInCart && !traded_in_model;
};
//# sourceMappingURL=useIsCheckoutBlockedByTradeIn.js.map